import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useQuery } from '@tanstack/react-query'
import { Button } from '@clari/ui'
import { CardPreview } from '@/components/banking/CardPreview'
import { bankingApi } from '@/lib/banking-api'

export function Cards() {
  const { t } = useTranslation('banking')
  const navigate = useNavigate()
  const accountsQuery = useQuery({ queryKey: ['accounts'], queryFn: () => bankingApi.listAccounts() })
  const account = accountsQuery.data?.items[0]
  const q = useQuery({
    queryKey: ['cards', account?.id],
    queryFn: () => bankingApi.listCards(account?.id ?? ''),
    enabled: Boolean(account),
  })

  return (
    <div className="mx-auto flex max-w-2xl flex-col gap-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">{t('cards.title')}</h1>
        <Button size="sm" onClick={() => navigate('/app/cards/new')} disabled={!account}>
          {t('cards.new')}
        </Button>
      </div>

      {q.isLoading ? <p className="text-text-muted">{t('common.loading')}</p> : null}
      {q.data && q.data.items.length === 0 ? (
        <p className="text-text-muted">{t('cards.none')}</p>
      ) : null}

      <div className="grid gap-4 sm:grid-cols-2">
        {q.data?.items.map((c) => (
          <Link key={c.id} to={`/app/cards/${c.id}`}>
            <CardPreview card={c} />
          </Link>
        ))}
      </div>
    </div>
  )
}
